import React from 'react';
import { useT } from '../i18n';
interface CountdownTimerProps {
  elapsed: number;
  stopped?: boolean;
}
export function CountdownTimer({
  elapsed,
  stopped = false
}: CountdownTimerProps) {
  const {
    t
  } = useT();
  const remaining = Math.max(0, 18 - elapsed);
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(elapsed / 18, 1);
  const strokeDashoffset = circumference * (1 - progress);
  return <div className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-full px-4 py-2 backdrop-blur-sm" data-id="element-33">
      <div className="relative w-9 h-9 flex-shrink-0" data-id="element-34">
        <svg className="w-9 h-9 -rotate-90" viewBox="0 0 36 36" data-id="element-35">
          <circle cx="18" cy="18" r={radius} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2.5" data-id="element-36" />
          <circle cx="18" cy="18" r={radius} fill="none" stroke={stopped ? '#05dd4d' : remaining === 0 ? '#05dd4d' : '#a1d4fd'} strokeWidth="2.5" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} className="transition-all duration-1000 ease-linear" data-id="element-37" />
        </svg>
        <span className={`absolute inset-0 flex items-center justify-center text-xs font-headline font-bold ${stopped || remaining === 0 ? 'text-solventum-primary' : 'text-white'}`} data-id="element-38">
          {stopped ? elapsed : remaining}
        </span>
      </div>

      <div className="flex flex-col" data-id="element-39">
        <span className="text-white/80 text-xs font-body leading-tight" data-id="element-40">
          {stopped ? t('timer.spent', {
          seconds: elapsed
        }) : remaining > 0 ? t('timer.discover') : t('timer.saved')}
        </span>
      </div>
    </div>;
}